export default "__VITE_ASSET__BJMEunKg__"